<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <!-- First step -->
            <div class="c-grid-row" v-if="formSteps.currentStep === formSteps.createFirebaseAccount">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="createFirebaseAccount()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
            <!-- Second step -->
            <div class="c-grid-row" v-if="formSteps.currentStep === formSteps.addDetailsToAccount">
              <div class="c-col-12 c-align-center">
                <button class="c-btn" v-on:click="addDetailsToAccount()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>
              </div>
            </div>            
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
          <!-- First Step - Create account on Firebase -->
          <form class="c-p-10" v-on:submit.prevent v-if="formSteps.currentStep === formSteps.createFirebaseAccount">            
            <div class="c-info-title-labels-wrap">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              <div class="c-info-title"><b>Dodavanje novog admina</b></div>
            </div>            
            <!-- New Admin Email -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="admin-account-email">Email</label>
                <input type="email" class="c-form-control" id="admin-account-email" name="admin-account-email"
                  v-model="formOneVars.email.model"
                >
              </div>
            </div>
            <!-- New Admin Password -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="admin-account-password">Lozinka</label>
                <input type="text" class="c-form-control" id="admin-account-password" name="admin-account-password"
                v-model="formOneVars.password.model"
                >
              </div>
            </div>
            <div class="c-form-divider">Upustvo:</div>
            <div class="c-fs-14 c-ux-color-white">Za dodavanje novog administratora, prvo je potrebno napraviti Firebase nalog pomocu email adrese i lozinke.<br/>Zatim, nakon sto Firebase doda novi nalog, popuniti opste informacije o korisniku</div>
          </form>
          <!-- Second Step - Add details for new account -->
          <form class="c-p-10" v-on:submit.prevent v-if="formSteps.currentStep === formSteps.addDetailsToAccount">
            <!-- Name, Last name -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="admin-first-name">Ime administratora</label>
                  <input type="text" class="c-form-control" id="admin-first-name" name="admin-first-name"
                  v-model="formTwoVars.firstName.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="admin-last-name">Prezime administratora</label>
                  <input type="text" class="c-form-control" id="admin-last-name" name="admin-last-name"
                  v-model="formTwoVars.lastName.model">
                </div>
              </div>
            </div>
            <!-- Nickname, Phone -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="admin-nickname">Nadimak</label>
                  <input type="text" class="c-form-control" id="admin-nickname" name="admin-nickname"
                  v-model="formTwoVars.nickName.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="admin-phone-number">Telefon</label>
                  <input type="text" class="c-form-control" id="admin-phone-number" name="admin-phone-number"
                  v-model="formTwoVars.phone.model">
                </div>
              </div>
            </div>
            <!-- Admin role -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="admin-role">Izaberi ulogu</label>
                <select class="c-form-control" id="admin-role" name="admin-role" v-model="formTwoVars.accessRoleKey.model">
                  <option disabled v-bind:value="null">Izaberite ulogu korisnika</option>
                  <option 
                    v-for="(singleAccessRole, key) in listOfAccessLevels" 
                    v-bind:value="singleAccessRole.accessLevel"
                    v-if="singleAccessRole.title"
                  >{{singleAccessRole.title}} ({{singleAccessRole.accessGroup}} Level - {{singleAccessRole.accessLevel}})</option>
                </select>
              </div>
            </div>
          </form>          
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          
          <div class="c-grid-row c-footer-action-buttons-wrap" v-if="formSteps.currentStep === formSteps.createFirebaseAccount">
            <div class="c-col-6 c-align-right">              
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="createFirebaseAccount()"><i class="fa fa-check" aria-hidden="true"></i> <b>Kreiraj</b></button>
            </div>
          </div>

          <div class="c-grid-row c-footer-action-buttons-wrap c-align-center" v-if="formSteps.currentStep === formSteps.addDetailsToAccount">
            <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="addDetailsToAccount()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
          </div>          
        </div>
      </footer> -->
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import Firebase from 'firebase'
import {firebaseDB} from '@/firebase';
export default {
  name: 'ModalCreateNewAdmin',
  props: ['inputModalData'],
  data () {
    return {
      isLoading: [1],
      msg: 'ModalCreateNewAdmin modal',
      // ~ Firebase unique identifier number after we created new Firebase user
      newlyCreatedUserData: null,
      //
      formSteps: {
        currentStep: 1,
        createFirebaseAccount: 1,
        addDetailsToAccount: 2
      },
      formOneVars: {
        isValid: false,
        email: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        password: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        }
      },
      formTwoVars: {
        isValid: false,
        firstName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        lastName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        nickName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        phone: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        email: {
          model: null
        },
        accessRoleKey: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        }        
      },
      //
      resolve: null,
      reject: null
    }
  },
  firebase: function () {
    return {
      listOfAccessLevels: {
        source: firebaseDB.ref('listOfAppAccessLevels'),
        //asObject: true,
        // optionally provide the cancelCallback, if the app client doesn't have permission to read from that database reference
        //cancelCallback: function (error) {console.log('!!! - IMPORTANT - cancelCallback');},
        // this is called once the data has been retrieved from firebase
        readyCallback: function (dataSnapshot) {
          this.isLoading.pop();
          //once we have list of all access levels, we can update 'selected option' to be one that user has
          //this.setSelectedAccessLevelFromUser(dataSnapshot);
        }
      }      
    }
  },
  watch: {
    'formTwoVars.accessRoleKey.model' : function (newValue){
      console.log('formTwoVars.accessRoleKey.model changed to: ' + newValue);
    }
  },  
  methods: {
    // ~ Create Firebase account so we can associate other informations for new user/admin
    createFirebaseAccount: function (){
      //console.log('~ start .. create new admin with email: ' + this.formOneVars.email.model + ', pass: ' + this.formOneVars.password.model);
      if (this.formOneVars.email.model && this.formOneVars.password.model){
        var request_email = this.formOneVars.email.model;
        var request_pass = this.formOneVars.password.model;
        Firebase.auth().createUserWithEmailAndPassword(request_email, request_pass).then(
          function (user) {
            //console.log('Firebase Account created succ: ' + JSON.stringify(user, null, 2));
            // next, change to next form to fill newly created admin informations
            this.formSteps.currentStep = this.formSteps.addDetailsToAccount;
            this.newlyCreatedUserData = user;
            //console.log('newlyCreatedUserData: ' + JSON.stringify(this.newlyCreatedUserData, null, 2));
            //this.getAvailableAdminRoles();
          }.bind(this),
          function (error){
            console.log('Firebase Account create ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
      }
    },
    // ~ Second step when we want to create Admin is to add/connect details to newly created account/user
    addDetailsToAccount: function (){
      var detailsFormIsValid = this.returnDetailsFormState();
      if (detailsFormIsValid === true){
        //
        //var newAccessTypeKey = firebaseDB.ref().child('listOfAppAccessLevels').push().key;
        firebaseDB.ref('listOfUsers').child(this.newlyCreatedUserData.uid).set({
          email: (this.newlyCreatedUserData.email) ? this.newlyCreatedUserData.email : null,
          enterPass: (this.formOneVars.password.model) ? this.formOneVars.password.model : null,
          firstName: (this.formTwoVars.firstName.model) ? this.formTwoVars.firstName.model : null,
          lastName: (this.formTwoVars.lastName.model) ? this.formTwoVars.lastName.model : null,
          nickName: (this.formTwoVars.nickName.model) ? this.formTwoVars.nickName.model : null,
          phone: (this.formTwoVars.phone.model) ? this.formTwoVars.phone.model : null,
          accessRoleKey: (this.formTwoVars.accessRoleKey.model) ? this.formTwoVars.accessRoleKey.model : null
        }).then(
          function (response) {
            //console.log('Firebase Account Create succ: ' + JSON.stringify(response, null, 2));
            var resultToReturn = {
              tempMsg: 'ModalCreateNewAdmin returns Yes'
            }
            this.resolve(resultToReturn);
          }.bind(this),
          function (error){
            console.log('Firebase Account Create ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
      }
    },
    returnDetailsFormState: function () {
      var returnValue = true;
      //
      return returnValue;
    },
    // getAvailableAdminRoles: function (){
    //   console.log('getAvailableAdminRoles');
    // },
    // ~ When we want to save changes created on this modal
    // saveChanges: function (){
    //   var resultToReturn = {
    //     tempMsg: 'ModalCreateNewAdmin returns Yes'
    //   }
    //   this.resolve(resultToReturn);
    // },
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    },
    // ~ Record UID for newly created Firebase user

  },
  created () {
    //console.log('~ created- ModalCreateNewAdmin component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalCreateNewAdmin component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalCreateNewAdmin component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/adminsList/ModalCreateNewAdmin.vue